<template>
  <ui-modal
    ref="modalRejectShippingInstruction"
    @close="closeModal('modalRejectShippingInstruction');  actionSetVisibleModalRejectShipping(false)"
    :title="multiple ? 'Detalles rechazo de Shipping Instructions'  :`Detalles rechazo de Shipping Instruction - ID ${id}`"
    size="normal">
    <div class="modal-body">
      <div class="form-group">
        <label>Razón de rechazo</label>
        <textarea type="text"
                  class="form-control"
                  v-model="reason"
                  placeholder="Por favor, ingrese una razón de rechazo de la Shipping Instruction..." maxlength="150"
                  rows="5">
          </textarea>
      </div>
    </div>
    <div class="modal-footer">
      <div class="w-50">
        <button class="btn btn-outline-primary"
                @click="closeModal('modalRejectShippingInstruction'); actionSetVisibleModalRejectShipping(false)">
          Cerrar
        </button>
      </div>
      <div class="w-50">
        <button class="btn btn-outline-danger float-right" @click="reject">
          Rechazar
        </button>
      </div>
    </div>
  </ui-modal>
</template>

<script>

import { mapState, mapActions } from "vuex";
import {
  // getShippingInstructionsPorAprobarFiltros,
  rechazarShippingInstruction
} from "@/constants/shippinginstructions";

export default {
  props: {
    id: { type: Number, default: 0 },
    data: { type: Array},
    multiple: { type: Boolean, default: false }
  },
  data() {
    return {
      reason: ""
    };
  },

  computed: {
    ...mapState("shippinginstructions", [
      "visibleModalRejectShipping",
      "si_filtered",
      "si_current_filters"
    ])
  },

  methods: {

    ...mapActions("shippinginstructions", [
      "actionSetVisibleModalRejectShipping",
      "actionSetSIFiltered",
      "actionSetDataDataShippingInstructionPorAprobarFiltrada",
      "actionSetVisibleModalInformacionShipping"
    ]),

    openModal(ref) {
      this.$refs[ref].open();
    },

    closeModal(ref) {
      this.$refs[ref].close();
      this.actionSetVisibleModalRejectShipping(false);
    },

    closeModalRef() {
      this.closeModal("modalRejectShippingInstruction");
    },

    async reject() {

      if (!this.reason || this.reason === "") {

        return this.$vToastify.error("Por favor, ingrese una razón de rechazo de la Shipping Instruction", "Error: Razón");

      }

      this.$vToastify.loader("Rechazando Shipping Instruction(s)...");

      let data;

      if (this.multiple) {

        data = { multiple: true, si_array: this.data, reason: this.reason ?? "N/A" };

      } else {

        data = { id: this.id, reason: this.reason ?? "N/A" };

      }

      let api_response = await rechazarShippingInstruction(data);

      if (api_response.status && api_response.status === true) {

        if (this.multiple) {

          this.$vToastify.info("Se han rechazado las Shipping Instructions seleccionadas", "Aviso");

        } else {

          this.$vToastify.info("Se ha rechazado la Shipping Instruction ID: " + this.id, "Aviso");

        }

        this.$vToastify.stopLoader();

        this.closeModalRef("modalRejectShippingInstruction");

        this.actionSetVisibleModalInformacionShipping(false);

        await this.$router.push({ name: 'shippingInstructionsRechazados' });

      } else if (api_response.status && api_response.status === false) {

        this.$vToastify.error("Se ha producido un error al rechazar la(s) Shipping Instruction(s)", "Error");

      }

    }
  },
  watch: {

    visibleModalRejectShipping: function(_new) {
      _new && this.openModal("modalRejectShippingInstruction");
    }

  }
};
</script>
